import { createContext } from 'react';

import { RecentGenerationMetadata } from '../../interfaces/recentGeneration';

export interface HistoryContextType {
  historyItems: RecentGenerationMetadata[];
  setHistoryItems: (items: RecentGenerationMetadata[]) => void;
}

const HistoryContext = createContext<HistoryContextType>({
  historyItems: [],
  setHistoryItems: () => {
    throw new Error(
      'setHistoryItems must be used within a HistoryContextProvider',
    );
  },
});
export default HistoryContext;
